import React from "react";
import { Modal } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./SharedModal.css";

const WordDefinitionModal = ({ show, handleClose, guess, wordDefinitions }) => {

    const hideModal = () => {
        handleClose();
    }

    const renderDefinitions = () => {
        if (wordDefinitions[guess] && wordDefinitions[guess].length > 0) {
            return wordDefinitions[guess].map((definition, index) => (
                <div key={index} className="modal-form-group">
                    <p className="text-word-definition">- {definition.definition}</p>
                </div>
            ));
        }
        return (
            <div className="modal-form-group">
                <p className="modal-text">No definitions available for this word.</p>
            </div>
        );
    }

    return (
        <Modal
            size="lg"
            centered
            show={show}
            onHide={hideModal}
            className="custom-modal"
        >
            <Modal.Header closeButton>
                <h2 className="modal-heading">Word Definition: {guess}</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="modal-definitions-container">
                    {renderDefinitions()}
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default WordDefinitionModal;